<template>
  <div v-loading="loading">
    <el-collapse v-model="activeNames" class="paddingRight10 paddingLeft10 labelGray">
      <el-collapse-item title="订单商品" name="0">
        <div v-for="(product, index) in seller" :key="index" class="marginBottom10">
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="bg-purple">
                <el-image v-if="product.goodsId === undefined" :src="noGoodsUrl" :preview-src-list="[noGoodsUrl]" class="h100 w100 borderRed" fit="fit"></el-image>
                <el-image v-else :src="product.c_master_url" :preview-src-list="[product.c_master_url]" class="h100 w100" fit="fit"></el-image>
              </div>
            </el-col>
            <el-col :span="16">
              <div class="bg-purple-light h100 flex directionColumn" style="justify-content: space-between">
                <a v-if="product.goodsId !== undefined" class="blue" @click="handleViewGoods(product.goodsId, product.r_sort, null)">{{ product.c_name }}</a>
                <div v-else class="elRed">{{ product.c_name }}</div>
                <el-row>
                  <el-col :span="11">
                    <el-button v-hasPermi="['shop:shopAuthorize:sellStart']" type="warning" size="mini" @click="handleSellStartOrOver(product.c_barcode, 1)">售罄</el-button>
                    <el-button v-hasPermi="['shop:shopAuthorize:sellOver']" type="warning" size="mini" @click="handleSellStartOrOver(product.c_barcode, 2)">复售</el-button>
                  </el-col>
                  <el-col :span="13">
                    <div class="textRight" :style="{ color: product.num > 1 ? 'red' : 'black' }"><span style="color: red;">实际价格：￥{{ product.price | parsePrice }}</span><span style="margin-left: 20px;">x{{ product.num }}</span></div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-collapse-item>
      <el-collapse-item title="订单拣货" name="1">
        <div v-for="(product, index) in goods" :key="index" class="marginBottom10">
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="bg-purple">
                <el-image v-if="product.rinventory !== undefined" :src="product.cmasterUrl" :preview-src-list="[product.cmasterUrl]" class="h100 w100" fit="fit"></el-image>
                <el-image v-else :preview-src-list="[noGoodsUrl]" class="h100 w100 borderRed" fit="fit"></el-image>
              </div>
            </el-col>
            <el-col :span="16">
              <div class="bg-purple-light h100 flex directionColumn" style="justify-content: space-between">
                <a v-if="product.rgoods !== undefined" class="blue">{{ product.sgoods }}</a>
                <div v-else class="elRed">{{ product.sgoods }}</div>
                <div>
                  货号：{{ product.csku }}，
                  <span style="color: red;" v-if="product.zinventory === '已出货' || product.zinventory === '已取消'">库位号：{{ product.zinventory }}</span>
                  <span v-else>库位号：{{ product.zinventory }}</span>
                </div>
                <div class="textRight" :style="{ color: product.nout > 1 ? 'red' : 'black' }">x{{ product.nout }}</div>
                <div v-show="product.goodsRemark" style="position: absolute; bottom: 0">货品备注: {{ product.goodsRemark }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="bcGrey h50 padding10 borderRadius5">
          <el-row>
            <el-col :span="11" style="height: 100px">
              <div class="grey">用户备注</div>
              <el-link v-if="orderInfo.sorderRemark === undefined || orderInfo.sorderRemark === ''" type="primary" @click="orderRemarkDialogVisible = true">点击添加备注</el-link>
              <el-link v-else type="primary" @click="orderRemarkDialogVisible = true">{{ orderInfo.sorderRemark }}</el-link>
            </el-col>
            <el-col :span="11" :offset="2" style="height: 100px">
              <div class="grey">内部备注</div>
              <el-link v-if="orderInfo.sadditionalRemark === undefined || orderInfo.sadditionalRemark === ''" type="primary" @click="sadditionalRemarkDialogVisible = true">点击添加备注</el-link>
              <el-link v-else type="primary" @click="sadditionalRemarkDialogVisible = true">{{ orderInfo.sadditionalRemark }}</el-link>
            </el-col>
          </el-row>
        </div>
        <div class="bcGrey h50 padding10 borderRadius5">
          <el-button v-if="pickInfo && pickInfo.zstate === 1" v-hasPermi="['order:orderProcessing:pickEdit']" type="primary" plain style="float: right" @click="openPicking(orderInfo.rpicking)">修改</el-button>
          <!-- <el-button v-if="pickInfo && pickInfo.zstate === 2" v-hasPermi="['order:orderProcessing:pickEdit']" type="primary" plain style="float: right; margin-left: 5px" @click="openPickingShipment()">快捷出货</el-button> -->
          <el-button v-if="pickInfo && pickInfo.zstate === 2" v-hasPermi="['order:orderProcessing:pickEdit']" type="primary" plain style="float: right; margin-left: 5px" @click="pickingShipmentDialogVisible = true">出货</el-button>
          <el-button v-if="pickInfo && pickInfo.zstate === 2" v-hasPermi="['order:orderProcessing:pickEdit']" type="danger" plain style="float: right; margin-left: 5px" @click="openPickingUpdate(orderInfo.rpicking)">改单</el-button>
          <el-button v-if="pickInfo && pickInfo.zstate === 2" v-hasPermi="['order:orderProcessing:pickEdit']" type="danger" plain style="float: right; margin-left: 5px" @click="openPickingCancel(orderInfo.rpicking)">取消</el-button>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div style="display: flex; flex-direction: row; justify-content: space-between; width: 100%">
            <div>顾客信息</div>
          </div>
        </template>
        <el-descriptions :column="1">
          <el-descriptions-item label="预定人">{{ orderInfo.ccustomerName + "&性别：" + orderInfo.ccustomerSex }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ orderInfo.ccustomerPhone }}</el-descriptions-item>
          <el-descriptions-item label="隐私号">
            <a class="blue" @click="callPhone(orderInfo.ccustomerPhonePrivate)">{{ orderInfo.ccustomerPhonePrivate ? orderInfo.ccustomerPhonePrivate.split("_")[0].replace(orderInfo.ccustomerPhonePrivate.substr(3, 4), "****") + "_****" : "" }}</a>
          </el-descriptions-item>
          <el-descriptions-item label="备用号"><a class="blue" @click="callPhone(orderInfo.ccustomerPhoneBak)">{{ orderInfo.ccustomerPhoneBak ? orderInfo.ccustomerPhoneBak.split("_")[0].replace(orderInfo.ccustomerPhoneBak.substr(3, 4), "****") + "_****" : "" }}</a></el-descriptions-item>
          <el-descriptions-item label="顾客属性">{{ orderInfo.ccustomerAttr }}</el-descriptions-item>
        </el-descriptions>
      </el-collapse-item>
      <el-collapse-item title="订单金额" name="3">
        <el-descriptions :column="1">
          <el-descriptions-item key="顾客实付" label="顾客实付">{{ orderInfo.npriceCustomer | parsePrice }} 元</el-descriptions-item>
          <el-descriptions-item key="商家实收" label="商家实收">{{ orderInfo.npriceShop | parsePrice }} 元</el-descriptions-item>
        </el-descriptions>
      </el-collapse-item>
      <el-collapse-item title="订单信息" name="4">
        <el-descriptions :column="1">
          <el-descriptions-item label="订单编号">{{ orderInfo.corderNo }}</el-descriptions-item>
          <el-descriptions-item label="下单时间">{{ orderInfo.sorderTime }}</el-descriptions-item>
          <el-descriptions-item v-if="orderInfo.bdelivery === 2" label="自提时间">{{ orderInfo.swishTime }}</el-descriptions-item>
          <el-descriptions-item v-else label="要求送达">{{ orderInfo.swishTime }}</el-descriptions-item>
          <el-descriptions-item v-if="orderInfo.soverTime" label="完成时间">{{ orderInfo.soverTime }}</el-descriptions-item>
          <el-descriptions-item label="配送门店">
            <a class="blue" @click="clickStoreLocation">{{ ccode + storeName }}</a>
          </el-descriptions-item>
        </el-descriptions>
      </el-collapse-item>
      <el-collapse-item v-if="!(orderInfo.zflow === 1 || orderInfo.zflow === 2)" title="配送信息" name="5">
        <el-descriptions :column="1">
          <el-descriptions-item label="配送方式">{{ orderInfo.logistic | deliveryPlatform }}</el-descriptions-item>
          <el-descriptions-item label="配送费用">{{ orderInfo.ndeliveryPrice }}</el-descriptions-item>
          <el-descriptions-item label="骑手姓名">{{ orderInfo.cdeliveryName }}</el-descriptions-item>
          <el-descriptions-item label="骑手电话">
            <a class="blue" @click="callPhone(orderInfo.cdeliveryPhone)">{{ orderInfo.cdeliveryPhone }}</a>
          </el-descriptions-item>
        </el-descriptions>
      </el-collapse-item>
    </el-collapse>
    <el-dialog v-if="imDialogVisible" custom-class="customDialog" class="elDialog my_dialog" :close-on-click-modal="false" title="客服中心" :visible.sync="imDialogVisible" width="700px" append-to-body>
      <imDialog v-if="imDialogVisible" :order-id="orderId" />
    </el-dialog>
    <el-dialog v-if="storeLocationDialogVisible" class="elDialog" :close-on-click-modal="false" title="门店位置" :visible.sync="storeLocationDialogVisible" width="800px" append-to-body>
      <getStoreLocation v-if="storeLocationDialogVisible" :store-id="orderInfo.rstore" />
    </el-dialog>
    <el-dialog style="margin-top: -10vh" class="elDialog" :close-on-click-modal="false" title="修改拣货单" :visible.sync="editOrUpdatePickingDialogVisible" width="1200px" append-to-body>
      <editPicking v-if="editOrUpdatePickingDialogVisible" :picking-id="pickInfo.sid" @handleClose="handleClose" />
    </el-dialog>
    <el-dialog class="elDialog" :close-on-click-modal="false" title="拣货出库" :visible.sync="pickingShipmentDialogVisible" width="1200px" append-to-body>
      <pickingShipment v-if="pickingShipmentDialogVisible" :sid="pickInfo.sid" @handleClose="handleClose" @handleUpdate="handleClose" />
    </el-dialog>
    <el-dialog class="elDialog" :close-on-click-modal="false" title="用户备注" :visible.sync="orderRemarkDialogVisible" width="200px" append-to-body>
      <el-input v-model="orderInfo.sorderRemark" type="textarea" :rows="3"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orderRemarkDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleOrderRemark">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog class="elDialog" :close-on-click-modal="false" title="内部备注" :visible.sync="sadditionalRemarkDialogVisible" width="200px" append-to-body>
      <el-input v-model="orderInfo.sadditionalRemark" type="textarea" :rows="3"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sadditionalRemarkDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAdditionalRemark">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import imDialog from "@/views/order/dialog/imDialog";
import getStoreLocation from "@/views/order/getStoreLocation.vue";
import editPicking from "@/views/order/dialog/editPicking.vue";
import deliveryPlatform from "@/api/delivery.js";
import pickingShipment from "@/views/order/dialog/pickingShipment.vue";
export default {
  name: "OrderDelivery",
  components: {
    imDialog,
    getStoreLocation,
    editPicking,
    pickingShipment,
  },
  filters: {
    deliveryPlatform(value) {
      if (!value) {
        return "暂无配送信息";
      }
      let str = value.split(",");
      let result = "";
      for (let i = 0; i < str.length; i++) {
        if (result.length > 0) {
          result += ",";
        }
        result += deliveryPlatform[str[i]];
      }
      return result;
    },
    parsePrice(price) {
      if (price === null || price === undefined || price === "null" || price === "undefined") {
        return 0;
      } else if (price === 0) {
        return 0;
      } else {
        return (price / 100).toFixed(2);
      }
    },
  },
  props: {
    orderId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      activeNames: ["1", "2", "3", "4", "5"],
      seller: [],
      pickInfo: {},
      goods: [],
      orderInfo: {},
      imDialogVisible: false,
      storeLocationDialogVisible: false,
      editOrUpdatePickingDialogVisible: false,
      pickingShipmentDialogVisible: false,
      orderRemarkDialogVisible: false,
      sadditionalRemarkDialogVisible: false,
      loading: false,
      ccode: "",
      storeName: "",
      noGoodsUrl: require("@/assets/noGoods.svg"),
    };
  },
  mounted() {
    this.handleInit();
  },
  methods: {
    handleInit() {
      this.loading = true;
      this.handleQuerySeller();
      this.handleGetOrderInfo();
    },
    handleClose() {
      this.editOrUpdatePickingDialogVisible = false;
      this.pickingShipmentDialogVisible = false;
      this.handleGetOrderInfo();
    },
    openPicking() {
      this.editOrUpdatePickingDialogVisible = true;
    },
    openPickingUpdate() {
      this.$confirm(`确认改单？`)
        .then((_) => {
          let url = `${this.baseUrls.ordPicking}/change`;
          let params = { sid: this.pickInfo.sid };
          this.topsAjax.post(url, params).then(() => {
            this.pickInfo.zstate = 1;
            this.editOrUpdatePickingDialogVisible = true;
          });
        })
        .catch((_) => {});
    },
    openPickingShipment() {
      this.$confirm(`确认出货？`).then((_) => {
        let url = `${this.baseUrls.ordPicking}/shipment`;
        let params = { sid: this.pickInfo.sid };
        this.loading = true;
        this.topsAjax.post(url, params).then(() => {
          this.loading = false;
          this.$message({
            message: "出货成功",
            type: "success",
          });
          this.handleGetOrderInfo();
        });
      });
    },
    openPickingCancel() {
      this.$confirm(`确认取消？`)
        .then((_) => {
          this.topsAjax.post(`${this.baseUrls.ordPicking}/cancelById`, { sid: this.pickInfo.sid }).then(() => {
            this.$message({
              message: "取消成功",
              type: "success",
            });
          });
        })
        .catch((_) => {});
    },
    clickStoreLocation() {
      this.storeLocationDialogVisible = true;
    },
    handleOrderRemark() {
      let url = `${this.baseUrls.third}/additionalRemark`;
      this.topsAjax.post(url, { orderId: this.orderId, sorderRemark: this.orderInfo.sorderRemark }).then(() => {
        this.orderRemarkDialogVisible = false;
        this.$message.success("保存完成");
      });
    },
    handleAdditionalRemark() {
      let url = `${this.baseUrls.third}/additionalRemark`;
      this.topsAjax.post(url, { orderId: this.orderId, additionalRemark: this.orderInfo.sadditionalRemark }).then(() => {
        this.sadditionalRemarkDialogVisible = false;
        this.$message.success("保存完成");
      });
    },
    handleQuerySeller() {
      let url = `${this.baseUrls.orderDetail}/queryList`;
      let params = {
        orderId: this.orderId,
      };
      this.topsAjax.get(url, params).then((response) => {
        this.seller = response;
      });
    },
    handleGetOrderInfo() {
      let url = `${this.baseUrls.third}/get/` + this.orderId;
      this.topsAjax.get(url).then((response) => {
        this.orderInfo = response;
        this.handleGetOrderCustom();
        this.handleGetPick();
        this.handleGetStoreInfo();
      });
    },
    handleGetOrderCustom() {
      let url = `${this.baseUrls.platCustomer}/getDataByOrderNo`;
      this.topsAjax.get(url, { orderNo: this.orderInfo.corderNo }).then((response) => {
        this.orderInfo.ccustomerName = response.ccustomerName;
        if (response.ccustomerSex === "1") {
          this.orderInfo.ccustomerSex = "男";
        } else if (response.ccustomerSex === "2") {
          this.orderInfo.ccustomerSex = "女";
        } else {
          this.orderInfo.ccustomerSex = "未知";
        }
        this.orderInfo.ccustomerPhonePrivate = response.ccustomerPhonePrivate;
        this.orderInfo.customerPhoneBak = response.customerPhoneBak;
        this.orderInfo.ccustomerPhone = response.ccustomerPhone;
        this.orderInfo.customerAttr = response.customerAttr;
      });
    },
    handleGetPick() {
      let params = { orderId: this.orderInfo.corderNo };
      this.topsAjax.get(`${this.baseUrls.ordPicking}/selectByOrderIdForOrder`, params).then((res) => {
        if (res.picking === undefined) {
          this.$message.error("未查询到拣货单");
        } else {
          this.pickInfo = res.picking;
          if (this.pickInfo.zstate === 3) {
            for (let i = 0; i < res.pickingDetailList.length; i++) {
              res.pickingDetailList[i].zinventory = "已出货";
            }
          } else if (this.pickInfo.zstate > 3) {
            for (let i = 0; i < res.pickingDetailList.length; i++) {
              res.pickingDetailList[i].zinventory = "已取消";
            }
          }
          this.goods = res.pickingDetailList;
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    handleGetStoreInfo() {
      this.topsAjax.get(`${this.baseUrls.orderStore}/selectById?sid=${this.orderInfo.rstore}`).then((response) => {
        this.ccode = response.store.ccode;
        this.storeName = response.store.cname;
      });
    },
    handleSellStartOrOver(barcode, type) {
      this.topsAjax.post(`${this.baseUrls.third}/stopOrStartSell`, { barcode, shopId: this.orderInfo.cshop, opera:2, type }).then(() => {
        this.$message.success("操作成功");
      });
    },
    callPhone(toTel) {
      this.$confirm(`是否拨打电话？`, {
        dangerouslyUseHTMLString: true,
      })
        .then((_) => {
          let url = `${this.baseUrls.websocket}/call?phone=${toTel}`;
          let params = {};
          this.topsAjax.get(url, params).then(() => {
            this.$message.success("请在呼叫中心客户端确认应答。");
          });
        })
        .catch((_) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex: 1;
  flex-direction: column;

  &__body {
    flex: 1;
  }
}
</style>

<style lang="scss" scoped>
.labelGray {
  .el-descriptions-item__label:not(.is-bordered-label) {
    color: #909399;
  }

  .el-descriptions-item__container .el-descriptions-item__content,
  .el-descriptions-item__container .el-descriptions-item__label {
    display: inline-flex;
    justify-content: flex-end;
    margin-right: 10px;
  }
}
.is-selected {
  /* 选中效果的样式 */
  border-color: #409eff;
}
.ordListInfo {
  .el-card__body,
  .el-main {
    padding: 0;
  }

  .el-collapse-item__header {
    height: auto;
    line-height: 20px;
    background-color: rgb(247, 248, 250) !important;
  }

  .el-collapse-item__wrap {
    background-color: rgb(247, 248, 250) !important;
  }
}

.el-collapse-item__content {
  padding-bottom: 0;
}

.el-descriptions--medium:not(.is-bordered) .el-descriptions-item__cell {
  padding-top: 0;
}

.green {
  background-color: #60e722;
}

.center {
  display: flex;
  justify-content: center;
}

.circle {
  width: 25px; /* 圆的直径 */
  height: 25px; /* 圆的直径 */
  border-radius: 50%; /* 使元素成为圆形的关键属性 */
}

.layout {
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px;
  margin-bottom: 5px;
}
</style>
<style lang="scss" scoped>
.red {
  background-color: gray;
}

.circular {
  border-radius: 50%;
}
</style>
